import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";

export const StyledTitleIcon = styled("div")`
    margin-right: ${sizes.small}px;
    flex: 0 0 auto;
`;
